import { useQueryClient } from '@tanstack/react-query';
import { useCallback } from 'react';

import { BackendRoute } from '../../config/index';
import { QueryKey } from '../../constants/index';
import { ApiService } from '../../services/index';
import { useAppQuery } from '../use-app-query.hook';

export const useCalcCustomSafe = ({
  scenarioId,
  safeId,
}: {
  safeId: string;
  scenarioId: string;
}) => {
  const queryClient = useQueryClient();

  const { data, isLoading } = useAppQuery<{
    capitalOwned: number;
    postRoundCapitalOwned: number;
    sharesConverted: number;
  }>({
    queryKey: [QueryKey.CALC_CUSTOM_SAFE, scenarioId, safeId],
    queryFn: () =>
      ApiService.get({
        endpoint: BackendRoute.SCENARIOS,
        routePath: [scenarioId, 'custom-safes', safeId, 'calc'],
      }),
    refetchOnMount: false,
    refetchOnReconnect: false,
    refetchOnWindowFocus: false,
    enabled: !!scenarioId && !!safeId,
  });

  const invalidateQuery = useCallback(() => {
    queryClient.invalidateQueries({ queryKey: [QueryKey.CALC_CUSTOM_SAFE] });
  }, [queryClient]);

  return {
    invalidateQuery,
    data,
    isLoading,
  };
};
